import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { CrmAssociationService } from '../../../shared-services/crm-services/crm-object-service/crm-association.service';
import { SNACKBAR_DURATION } from '../../../constants';

export interface RemoveAssociationData {
  associationID: string;
  fromName: string;
  removeName: string;
}

@Component({
  selector: 'crm-remove-association-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule, MatButtonModule],
  templateUrl: './remove-association-dialog.component.html',
  styleUrls: ['./remove-association-dialog.component.scss'],
})
export class RemoveAssociationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RemoveAssociationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: RemoveAssociationData,
    private readonly crmAssociationService: CrmAssociationService,
    private readonly snackService: SnackbarService,
  ) {}

  remove(): void {
    this.crmAssociationService.removeAssociation(this.data.associationID).subscribe({
      next: () => {
        this.snackService.openSuccessSnack('ASSOCIATIONS.REMOVE_DIALOG.SUCCESS', {
          duration: SNACKBAR_DURATION,
        });
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackService.openErrorSnack('ASSOCIATIONS.REMOVE_DIALOG.ERROR', {
          duration: SNACKBAR_DURATION,
        });
      },
    });
  }
  cancel(): void {
    this.dialogRef.close();
  }
}
